export default __webpack_public_path__ + "static/media/noexpl_14_EN.1a3ccce2.png";